import { useEffect, useRef, useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { getCleanHTML } from 'shared/lib/getCleanHTML.ts'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  text?: string
}

export const UmraTourDescription = ({ text }: Props) => {
  const { t } = useTranslation()

  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false)
  const [shouldShowButton, setShouldShowButton] = useState(false)

  const descriptionRef = useRef<HTMLParagraphElement>(null)

  const toggleDescription = () => {
    setIsDescriptionExpanded(!isDescriptionExpanded)
  }

  useEffect(() => {
    const checkLines = () => {
      if (descriptionRef.current) {
        const element = descriptionRef.current

        const lineHeight = parseInt(window.getComputedStyle(element).lineHeight)
        const maxHeight = lineHeight * 10

        setShouldShowButton(element.scrollHeight > maxHeight)
      }
    }

    const timeoutId = setTimeout(checkLines, 0)

    return () => clearTimeout(timeoutId)
  }, [text])

  return (
    <Paper
      className={s.container}
      padding={[12, 16, 12, 16]}
    >
      <div className={clsx(s.content, !isDescriptionExpanded && s.collapsed)}>
        <div
          ref={descriptionRef}
          dangerouslySetInnerHTML={{
            __html: getCleanHTML(text || '', {
              forbiddenTags: ['img', 'svg'],
            }),
          }}
        />
      </div>

      {shouldShowButton && (
        <div
          onClick={toggleDescription}
          className={s.btn}
        >
          <AppIcon
            className={clsx(s.icon, isDescriptionExpanded && s.icon__open)}
            id={AllIcons.CHEVRON_RIGHT}
            width={12}
            height={12}
          />
          <span className={'semi-bold-14'}>
            {isDescriptionExpanded
              ? t('umrah_block.collapse')
              : t('umrah_block.more')}
          </span>
        </div>
      )}
    </Paper>
  )
}
